import { apiFetch } from './apiFetch';

export async function getSession() {
  await apiFetch(process.env.REACT_APP_GUEST, {
    method: 'POST',
  });
  return true;
}

export async function login(telefono, password) {
  const data = await apiFetch(process.env.REACT_APP_LOGIN, {
    method: 'POST',
    body: JSON.stringify({ telefono, password }),
  });

  return data;
}

export async function logout() {
  await apiFetch(`${process.env.REACT_APP_API_URL}/auth/logout`, {
    method: 'POST',
  });
  return true;
}
